import { useReactiveVar } from '@apollo/client';
import { methodModalVar } from 'features/commissionCalculationMethods/variables';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import MethodComponent from './MethodComponent';

const MethodModalComponent = () => {
  const methodModal = useReactiveVar(methodModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    methodModalVar({ open: false });
  }, []);

  return (
    <Dialog open={methodModal.open} fullWidth maxWidth='md' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{methodModal.open && <MethodComponent method={methodModal.method} />}</DialogContent>
    </Dialog>
  );
};

export default MethodModalComponent;
